export function getFromLocalStorage(workspaceKey) {
  let fromStorage = null;
  try {
    fromStorage = JSON.parse(localStorage.getItem(workspaceKey));
  } catch (_) {
  }
  const spaceAsObject = fromStorage ?? {};
  return new Map(Object.entries(spaceAsObject));
}
export function persistToLocalStorage(workspace, workspaceKey) {
  const asObject = [...workspace.entries()].reduce((partial, [key, item]) => ({
    ...partial,
    [key]: item
  }), {});
  try {
    localStorage.setItem(workspaceKey, JSON.stringify(asObject));
  } catch (error) {
    console.error(error);
  }
}
